document.addEventListener('DOMContentLoaded', () => {

    function getUserId() {
    return document.body.dataset.customer || undefined;
    }

    function getUserType() {
    return document.body.dataset.customer != "" ? 'logged_in' : 'non_logged_in';
    }

    function getPlatform() {
    return /Mobi|Android/i.test(navigator.userAgent) ? 'M-web' : 'D-web';
    }

    function getPageType() {
    return document.body.dataset.template;
    }

    window.dataLayer.push({
        page_type: getPageType(),
        user_id_event: getUserId(),
        user_status: getUserType(),
        platform: getPlatform(),
    });


    function isElementVisible(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top < window.innerHeight &&
            rect.bottom > 0 &&
            rect.left < window.innerWidth &&
            rect.right > 0
        );
    }


    // view_promotion
    const slideP = document.querySelector('.slideshow__slide.is-selected[data-view_promotion]');
    if(slideP && isElementVisible(slideP)){
        if (slideP.dataset.tracked === "true") return;
        slideP.dataset.tracked = "true";
        const creativeName = slideP.dataset.creative_name || "Unknown Banner";
        const creativeSlot = slideP.dataset.creative_slot || "NA";
        const promotionId = slideP.dataset.promotion_id || "NA";
        const promotionName = slideP.dataset.promotion_name || creativeName;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });

        window.dataLayer.push({
            event: "view_promotion_ce",
            page_type: getPageType(),
            user_id_event: getUserId(),
            user_status: getUserType(),
            platform: getPlatform(),
            ecommerce: {
                creative_name: creativeName,
                creative_slot: creativeSlot,
                promotion_id: promotionId,
                promotion_name: promotionName
            }
        });
    }

    // select_promotion
    function trackPromotionSelection() {
        const promoBanners = document.querySelectorAll('a.slideshow__slide[data-view_promotion], div.slideshow__slide[data-view_promotion] .button-group a');
        promoBanners.forEach((banner) => {
            banner.addEventListener('click', () => {
                // console.log("banner",banner);
                if(banner.classList.contains("button")){
                    banner = banner.closest('[data-view_promotion]');
                }
                // console.log("banner",banner);
                let creativeName = banner.getAttribute('data-creative_name') || 'Unknown Banner';
                let creativeSlot = banner.getAttribute('data-creative_slot') || 'NA';
                let promotionId = banner.getAttribute('data-promotion_id') || 'NA';
                let promotionName = banner.getAttribute('data-promotion_name') || creativeName;
                if (creativeName != null) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push({
                        event: 'select_promotion_ce',
                        page_type: getPageType(),
                        user_id_event: getUserId(),
                        user_status: getUserType(),
                        platform: getPlatform(),
                        ecommerce :{
                            creative_name: creativeName,
                            creative_slot: creativeSlot,
                            promotion_id: promotionId,
                            promotion_name: promotionName,
                        }
                    });
                }
            });
        });
    }
    trackPromotionSelection();

    // view_item_list
    function debounce(fn, delay) {
        let t;
        return function (...args) {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), delay);
        };
    }
    let productCardsVIL = [];
    
    // if (!productCardsVIL.length) return;
    window.dataLayer = window.dataLayer || [];
    const seenCards = new Set();
    const buildItemFromCard = (card) => {
        let sort_applied = "NA";
        let activeFilters = [];
        if(document.body.classList.contains("template-collection")){
            sort_applied = document.querySelector(`facets-sort-popover button[aria-selected="true"] span`).textContent;
            document.querySelectorAll(`.facets-sidebar facets-form input:checked`).forEach((input) => {
                const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                const labelText = input.dataset.value;
                activeFilters.push(`${groupLabel}-${labelText}`);
            });
            const priceMin = document.querySelector(".facets-sidebar price-range input[name='filter.v.price.gte']")?.value;
            const priceMax = document.querySelector(".facets-sidebar price-range input[name='filter.v.price.lte']")?.value
            if (priceMin || priceMax) {
                activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
            }
        }
        let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";
        // console.log("appliedValue",appliedValue);
        return {
            index: (Array.from(card.parentNode.children).indexOf(card) + 1),
            item_id: card.getAttribute('data-item-id'),
            item_name: card.getAttribute('data-item-name') || 'Unknown Product',
            item_variant: card.getAttribute('data-item-variant') || 'NA',
            price: parseFloat(card.getAttribute('data-item-price')) || 0,
            item_category: card.getAttribute('data-item-category') || 'NA',
            item_category2: card.getAttribute('data-item-category2') || 'NA',
            item_category3: card.getAttribute('data-item-category3') || 'NA',
            item_category4: card.getAttribute('data-item-category4') || 'NA',
            item_category5: appliedValue,
            item_list_id: card.closest(`[data-item-list-id]`).getAttribute('data-item-list-id') || 'collection_page',
            item_list_name: card.closest(`[data-item-list-name]`).getAttribute('data-item-list-name') || 'NA',
        };
    };

    // IntersectionObserver to detect when cards enter viewport
    const handleEntries = debounce((entries) => {
            const visibleItems = [];
            // console.log("entriesentriesentries",entries);
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const card = entry.target;
                    const cardId = card.getAttribute('data-item-id');
                    // Avoid firing multiple times for the same card
                    if (!card.classList.contains("gtm-added")) {
                        card.classList.add("gtm-added");
                        visibleItems.push(buildItemFromCard(card));
                    }
                }
            });
            
            if (visibleItems.length) {
                // Push GA4 event only for newly visible items
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                event: "view_item_list_ce",
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform(),
                ecommerce: { items: visibleItems },
                });
            }
    }, 0);
    const observer = new IntersectionObserver(handleEntries, {
        threshold: 0
    });
    
    if(document.body.classList.contains("template-product")){
        let tries = 0;
        const maxTries = 10;
        const intervalId = setInterval(() => {
            let productCardsVIL1 = Array.from(document.querySelectorAll("product-card"));
            // console.log("productCardsVIL", productCardsVIL1);
            if (productCardsVIL1.length > 0) {
                productCardsVIL = productCardsVIL1;
                productCardsVIL.forEach((card) => observer.observe(card));
                clearInterval(intervalId); // stop when found
            }
            tries++;
            if (tries >= maxTries) {
                clearInterval(intervalId); // stop after 10 tries
            }
        }, 1000);

    }else{
        // console.log("productCardsVIL",productCardsVIL);
        let productCardsVIL1 = Array.from(document.querySelectorAll("product-card"));
        if (productCardsVIL1.length > 0) {
            productCardsVIL = productCardsVIL1;
            productCardsVIL.forEach((card) => observer.observe(card));
        }
    }


    // select_item
    function selectItemInit(){
        const viewedProducts = new Set();
        const productCards = document.querySelectorAll('product-card');
        if (!productCards.length) return;
        productCards.forEach((card) => {
            card.addEventListener('click', function (event) {
                // Allow only clicks on product card or its children
                if (!event.target.closest('product-card')) return;
                let sort_applied = "NA";
                let activeFilters = [];
                if(document.body.classList.contains("template-collection")){
                    sort_applied = document.querySelector(`facets-sort-popover button[aria-selected="true"] span`).textContent;
                    document.querySelectorAll(`.facets-sidebar facets-form input:checked`).forEach((input) => {
                        const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                        const labelText = input.dataset.value;
                        activeFilters.push(`${groupLabel}-${labelText}`);
                    });
                    const priceMin = document.querySelector(".facets-sidebar price-range input[name='filter.v.price.gte']")?.value;
                    const priceMax = document.querySelector(".facets-sidebar price-range input[name='filter.v.price.lte']")?.value
                    if (priceMin || priceMax) {
                        activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
                    }
                }
                let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";

                // Prepare GA4 item object
                const itemData = {
                    index: (Array.from(card.parentNode.children).indexOf(card) + 1),
                    item_id: card.getAttribute('data-item-id'),
                    item_name: card.getAttribute('data-item-name') || 'Unknown Product',
                    item_variant: card.getAttribute('data-item-variant') || 'NA',
                    price: parseFloat(card.getAttribute('data-item-price')) || 0,
                    item_category: card.getAttribute('data-item-category') || 'NA',
                    item_category2: card.getAttribute('data-item-category2') || 'NA',
                    item_category3: card.getAttribute('data-item-category3') || 'NA',
                    item_category4: card.getAttribute('data-item-category4') || 'NA',
                    item_category5: appliedValue,
                    item_list_id: card.closest(`[data-item-list-id]`).getAttribute('data-item-list-id') || 'collection_page',
                    item_list_name: card.closest(`[data-item-list-name]`).getAttribute('data-item-list-name') || 'NA',
                    quantity: 1
                };
                localStorage.setItem(`index_${card.getAttribute('data-item-id')}`, (Array.from(card.parentNode.children).indexOf(card) + 1));
                localStorage.setItem(`item_list_id_${card.getAttribute('data-item-id')}`, card.closest(`[data-item-list-id]`).getAttribute('data-item-list-id') || 'collection_page');
                localStorage.setItem(`item_list_name_${card.getAttribute('data-item-id')}`, card.closest(`[data-item-list-name]`).getAttribute('data-item-list-name') || 'NA');
                // GA4 push
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'select_item_ce',
                    page_type: getPageType(),
                    user_id_event: getUserId(),
                    user_status: getUserType(),
                    platform: getPlatform(),
                    ecommerce: { items: [itemData] }
                });
            });
        });
    }
    // select_item init
    selectItemInit();

    //search_interaction
    // search_term_entered
    document.addEventListener("click", function (event) {
        var suggestionLink = event.target.closest(".predictive-search__products a");
        if(suggestionLink){
            console.log("search suggestions click");
            // Get search term from input
            var searchInput = document.querySelector(`form[action="/search"] input[type="search"]`);
            var currentTerm = searchInput ? searchInput.value.trim() : '';
            if (!currentTerm) return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'search_interaction',
                section_name: 'Search Suggestions',
                selection_type: 'suggested_search_term',
                search_term_entered: currentTerm,
                destination_url: suggestionLink.href,
                link_text: suggestionLink.innerText,
                // link_path: window.location.href,
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform()
            });
        }
    });

    // cta_click
    document.querySelectorAll(`[data-cta_click]`).forEach(ctaBtn => {
        ctaBtn.addEventListener("click",function(){
            let section_name = this.dataset.cta_click;
            if(ctaBtn.closest(".section-featured-collections")){
                // console.log("aaaaaa",ctaBtn.closest(".section-featured-collections").querySelector(`[data-fc-heading][aria-current="true"]`));
                section_name = ctaBtn.closest(".section-featured-collections").querySelector(`[data-fc-heading][aria-current="true"]`).innerText.trim();
            }
            window.dataLayer.push({
            event: 'cta_click',
            section_name: section_name,
            cta_text: this.innerText.trim(),
            destination_url: this.href,
            page_type: getPageType(),
            platform: getPlatform(),
            user_id_event: getUserId(),
            user_type_event: getUserType(),
            });
        });
    });

    // link_click
    document.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-link_click') || e.target.closest('[data-link_click]')) {
            let target = e.target.hasAttribute('data-link_click') ? e.target : e.target.closest('[data-link_click]');
            console.log("TARGET",target);
            console.log('Clicked view more');
            window.dataLayer.push({
            event: 'link_click',
            link_text: target.innerText.trim(),
            destination_url: target.href,
            page_type: getPageType(),
            platform: getPlatform(),
            user_id_event: getUserId(),
            user_type_event: getUserType(),
            });
        }
    });
    // document.querySelectorAll(`[data-link_click]`).forEach(ctaBtn => {
    //     ctaBtn.addEventListener("click",function(){
    //         window.dataLayer.push({
    //         event: 'link_click',
    //         link_text: this.innerText.trim(),
    //         destination_url: this.href,
    //         page_type: getPageType(),
    //         platform: getPlatform(),
    //         user_id_event: getUserId(),
    //         user_type_event: getUserType(),
    //         });
    //     });
    // });
    

});



